import { useSelector, useDispatch } from "react-redux";
import { openSpinner, closeSpinner } from "store/modules/common/spinnerReducer";

const useSpinner = () => {
    const spinnerState = useSelector((state) => state.spinnerReducer);
    const dispatch = useDispatch();

    const handleOpenSpinner = (info) => {
        dispatch(openSpinner(info));
    };

    const handleCloseSpinner = () => {
        dispatch(closeSpinner());
    };

    return {
        spinnerState,
        openSpinner: handleOpenSpinner,
        closeSpinner: handleCloseSpinner,
    };
};

export default useSpinner;
